// extracted by mini-css-extract-plugin
export var body = "_2p-1";
export var bodyPadded = "_2p-2";
export var chevron = "_2p-4";
export var chevronOpen = "_2p-5";
export var header = "_2p-0";
export var icon = "_2p-3";